/**
 * Speechify — Text to Speech
 *
 * Exposes a broad WAR group to `<all_urls>` with `use_dynamic_url: false` — including
 * `images/*`, `features.json`, `houdini.js` and `content/*` — so each bundled file is
 * fetchable from any page at a stable URL. The vendor-named `houdini.js` and the
 * top-level `features.json` are distinctive, and the image set loads through
 * `probeImage` with no CORS grant.
 *
 * Manifest verified against version 14.1.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ljflmlehinmoeknoonhibbjpldiijjmm';

export const speechify: ExtensionDefinition = {
  id: ID,
  name: 'Speechify — Text to Speech',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  notes:
    'Wide static WAR group on <all_urls> (images/*, features.json, houdini.js, ...) with ' +
    'use_dynamic_url:false. The logo image loads without a CORS grant; detection is conclusive.',
  signals: [
    {
      id: 'war-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Load images/logo.svg via <img> — a branding asset exposed to every origin that ' +
        'loads without a CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/logo.svg'),
    },
    {
      id: 'war-houdini-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch houdini.js — a vendor-named top-level script exposed to <all_urls>, an ' +
        'independent corroborating path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'houdini.js'),
    },
    {
      id: 'war-features-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch features.json — the top-level feature manifest exposed to every origin, a ' +
        'third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'features.json'),
    },
  ],
};
